import { BrickInfos, brick_registerer } from '@/components/bricks_infos_core.js'
import BrickGenericModelgenerator from '@/components/brick_generic_modelgenerator.vue'
import SummaryModel from '@/components/summary_model.vue'
import Vue from 'vue'

Vue.component('SummaryModel', SummaryModel)

let infos = new BrickInfos()

infos.back_classes = ['fas', 'fa-certificate', 'text-purple']
infos.front_classes = ['fas', 'fa-tree-alt', 'text-white']
infos.name = 'modelgen'
infos.associated_class_name = 'AutomlGenericModelgenerator'
infos.editing_component_name = 'BrickGenericModelgenerator'
infos.editing_component = BrickGenericModelgenerator
infos.summary_component_name = 'SummaryModel'
infos.summary_component = SummaryModel
infos.descriptions = {
	en: {
		short_tooltip_description: 'Model generator',
		full_tooltip_description: 'Generates a predictive model',
		navbar_name: 'Model generator',
	},
	fr: {
		short_tooltip_description: 'Générateur de modèles',
		full_tooltip_description:
			"Configuration de l'apprentissage du modèle prédictif",
		navbar_name: 'Générateur de modèles',
	},
}
// infos.short_tooltip_description = 'modelgen_short_tooltip'
// infos.full_tooltip_description = 'modelgen_full_tooltip'
// infos.navbar_name = 'modelgen_navbar'
infos.background_color = 'purple'

brick_registerer(infos)
